import { Navigate, Outlet } from 'react-router-dom';

import { getEnvConfig } from 'config/environment';
import { ENABLE_LEAGUES } from 'config/flags/featureFlag';
import { NOT_FOUND } from 'config/router/constants';

/**
 * LeagueOutlet an outlet to show leagues pages depending on whether or not
 * we have the REACT_APP_ENABLE_LEAGUES env var enabled.
 * Once live we should remove this component.
 * https://clubspark.atlassian.net/browse/COMP-12829
 * @returns Route
 */
const LeagueOutlet = () => {
  const leaguesEnabled = getEnvConfig()[ENABLE_LEAGUES] === 'true';

  if (!leaguesEnabled) {
    return <Navigate replace to={NOT_FOUND} />;
  }

  return <Outlet />;
};

export default LeagueOutlet;
